export const initTeamExpand = () => {
  const items = Array.from(document.querySelectorAll('[data-team-item]'));
  if (items.length === 0) {
    return;
  }

  items.forEach((item) => {
    const toggle = item.querySelector('.c-team__toggle');
    const content = item.querySelector('.c-team__content');
    if (!toggle || !content) {
      return;
    }

    const handleToggle = () => {
      const isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      content.toggleAttribute('hidden', !isOpen);
    };

    toggle.addEventListener('click', handleToggle);
    item.addEventListener('click', (event) => {
      if (event.target.closest('.c-team__toggle')) {
        return;
      }
      handleToggle();
    });
  });
};
